import ProductListPrompt from "emun.products/lists/product-list-prompt";
import ProductListQuickViewer from "emun.products/lists/product-list-quick-viewer";
import cache from "emun.products/lists/product-list.cache";
import ProductQuery from "emun.shopping/product-query.service";
import shoppingConfig from "emun.shopping/shopping.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import yotPoConfig from "emun.shopping/yotpo.config";
export const IS_FRANCE = (ENV_TAGS || []).indexOf("France") >= 0; //webpack.DefinePlugin
import { replaceSpaces } from "webutils/services/util";

let instance = 0;
export default class ShoppingContainerController /*extends ShopController*/ {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.ngModel = $ctrl;
    this.replaceSpaces = replaceSpaces;
  }

  $onChanges(args) {
    const $ctrl = this;
    if (!$ctrl.query) return;
    if (args.productIds && Array.isArray(args.productIds.currentValue)) {
      $ctrl.query.filter("IdIn", args.productIds.currentValue.join(","));
    }
    if (args.catalogPageId && args.catalogPageId.currentValue) {
      $ctrl.query.filter("CatalogPageId", args.catalogPageId.currentValue);
    }
  }

  $onInit() {
    const $ctrl = this;
    const $location = $ctrl.$ioc("$location");
    $ctrl.queryParams = $location.search();
    $ctrl.modals = modals;
    // console.debug("BL*** queryParams = ", {
    //   ...$ctrl.queryParams,
    //   ...$ctrl.$stateParams,
    // });
    if ($ctrl.queryParams.hideLeftNav) $ctrl.hideLeftNav = true;
    $ctrl.$cart.$$load.finally(() => {
      // $ctrl.retailerId = $ctrl.$cart.retailerId || $ctrl.$session.retailerId;
      $ctrl.productLists = new AutoQuery({
        url: "QueryProductLists.json?src=ShoppingContainerController",
        hideLeftNav: true, // $ctrl.$page.is('gt-sm'),
        orderBy: "-CreatedOn,Id",
        createdOn: new Date().getTime(),
        instance: instance++,
        autoLoad: true,
        criteria: {
          expired: false,
          ListType: "WISHLIST",
          //retailerId: $ctrl.retailerId
        },
        beforeLoading({ request }) {
          if ($ctrl.$session.businessModel !== "Retail") {
            request.RetailerId = cache.resolveRetailerId();
          }
          // request.cartId = $ctrl.$cart.id;
        },
        afterLoaded: () => $ctrl.query && $ctrl.query.getRefinements(),
        scrub({ data: { results } }) {
          $ctrl.productLists.editable = results.filter((l) => l.editable);
          $ctrl.productLists.visible = results.filter((l) => l.visible);
        },
        pageSize: 88,
      });
      const defaultConfig = {
        disableQueryString:
          $ctrl.disableQueryString === true ||
          ["nav", "grid"].indexOf($ctrl.type) >= 0,
        fields:
          $ctrl.type === "nav" ? "Id" : $ctrl.fields || shoppingConfig.fields,
        filters:
          $ctrl.type !== "grid" && ($ctrl.filters || shoppingConfig.filters),
        navs: $ctrl.type !== "grid" && ($ctrl.navs || shoppingConfig.navs),
        disableSettingStorage: !!(
          $ctrl.disableSettingStorage || shoppingConfig.disableSettingStorage
        ),
        sortOptions: $ctrl.sortOptions || shoppingConfig.sortOptions,
        tagCriteria: $ctrl.tagCriteria,
        httpMethod: $ctrl.httpMethod,
        scrollTop: shoppingConfig.scrollTop,
        hideLeftNav:
          $ctrl.hideLeftNav !== undefined
            ? $ctrl.hideLeftNav
            : shoppingConfig.hideLeftNav($ctrl),
        onBeforeTagInit: $ctrl.onBeforeTagInit.bind($ctrl),
        beforeLoading: (args) => $ctrl.beforeLoading(args),
        afterLoaded: (args) => $ctrl.afterLoaded(args),
        criteria: {
          IdIn: Array.isArray($ctrl.productIds)
            ? $ctrl.productIds.join(",")
            : undefined,
          search: $ctrl.search,
          ListId:
            (!$ctrl.disableQueryString && $ctrl.$stateParams.ListId) ||
            $ctrl.listId,
          MutEx: $ctrl.$stateParams.MutEx,
          wholesalePriceGreaterThanOrEqualTo: $ctrl.priceMin,
          wholesalePriceLessThanOrEqualTo: $ctrl.priceMax,
          context: $ctrl.context || shoppingConfig.queryProductsContext,
          ...(shoppingConfig.queryProductsCriteria || {}),
        },
        views: shoppingConfig.views,
        view: $ctrl.queryParams.initialView || $ctrl.initialView || "cards",
        onGotRefinements(refinements) {
          $ctrl.productLists.results.forEach((list) => {
            if (
              list.id === $ctrl.query.criteria.ListId ||
              list.id === $ctrl.listId ||
              list.id === $ctrl.queryParams.listId
            )
              refinements.push({
                label: "List: " + list.label,
                remove: () => $ctrl.query.toggle("ListId", list.id),
              });
          });
        },
      };

      defaultConfig.autoLoad = $ctrl.getAutoLoad();
      if ($ctrl.type === "nav") defaultConfig.pageSize = 1;
      if (!$ctrl.productId && $ctrl.$session.sessionStorage.productId) {
        $ctrl.productId = $ctrl.$session.sessionStorage.productId;
        //https://emun1.monday.com/boards/333027351/views/4635648/pulses/3279691399
        console.warn(
          "$ctrl.$session.sessionStorage.productId",
          $ctrl.$session.sessionStorage.productId
        );
      }
      $ctrl.query = new ProductQuery(
        Object.assign(defaultConfig, $ctrl.queryOptions)
      );
      if ($ctrl.context == "product-recommendations")
        $ctrl.query.orderBy = undefined;
      //console.info("ShoppingContainerController", $ctrl);
      $ctrl.shoppingConfig = shoppingConfig;
      $ctrl.messages = shoppingConfig.messages;
      if (!$ctrl.panelType) $ctrl.panelType = shoppingConfig.panelType;
      $ctrl.hideNavContinueShopping = shoppingConfig.hideNavContinueShopping;
      $ctrl.showNavPanel = shoppingConfig.showNavPanel;
      $ctrl.navTitle = shoppingConfig.navTitle;
      if (!$ctrl.baseRoute) $ctrl.baseRoute = "shop";
      
      $ctrl.yotPoConfig = yotPoConfig;
      
      if ($ctrl.catalogPageId) {
        $ctrl.query.filter("CatalogPageId", $ctrl.catalogPageId);
      }
      //  $ctrl.$on('cartReady', () => $ctrl.productLists.load(true));
      $ctrl.$on("cartInitialized", () => {
        $ctrl.query.load(true);
        $ctrl.productLists.load(true);
      });
      $ctrl.$on("cartLoaded", () => $ctrl.generateHighlights());
      $ctrl.$on("refresh-product-lists", () => $ctrl.productLists.load(true));
      $ctrl.$on("productSelected", (e, { productId }) => {
        $ctrl.productId = productId;
      });
    });
  }

  $onDestroy() {
    const $ctrl = this;
    $ctrl.query.dispose();
    $ctrl.productLists.dispose();
  }

  onBeforeTagInit(pq) {
    const $ctrl = this;
    // console.debug("onBeforeTagInit", { pq, $ctrl });
  }

  beforeLoading({ request }) {
    const $ctrl = this;
    request.retailerId = cache.resolveRetailerId();
    request.cartId = $ctrl.$cart.id;
    if ($ctrl.query.orderBy == "Search") $ctrl.query.orderBy = $ctrl.shoppingConfig.orderBy;
  }
  afterLoaded(args) {
    const $ctrl = this;
    $ctrl.$broadcast("shopping-query-loaded", args);
    if ($ctrl.shuffleResults) args.results = $ctrl.shuffle(args.results);
    args.results.forEach((p) => p.generateHighlights());
  }

  shuffle(array) {
    let i = array.length;
    while (i > 0) {
      const ri = Math.floor(Math.random() * i);
      i--;
      [array[i], array[ri]] = [array[ri], array[i]];
    }
    return array;
  }

  getAutoLoad() {
    const $ctrl = this;
    // console.info(
    //   "getAutoLoad",
    //   $ctrl.$session.salesManagementMode,
    //   Array.isArray($ctrl.productIds),
    //   !$ctrl.tagCriteria,
    //   $ctrl.$state.current.name
    // );
    if (
      $ctrl.$session.salesManagementMode &&
      !Array.isArray($ctrl.productIds) &&
      !$ctrl.tagCriteria &&
      !$ctrl.$state.current.name.startsWith("shop")
    ) {
      // console.info("FiltersOnly");
      return "FiltersOnly";
    }
    // if ($ctrl.type === "grid")
    return true;
  }

  viewProductLists() {
    return ProductListQuickViewer({});
  }

  generateHighlights() {
    const $ctrl = this;
    $ctrl.query.results.forEach(function (p) {
      setTimeout(function () {
        p.generateHighlights();
      }, 250);
    });
  }

  getList() {
    const $ctrl = this;
    return $ctrl.productLists.results.filter((l) => l.id === cache.get())[0];
  }

  hasList() {
    const $ctrl = this;
    const list = $ctrl.getList();
    if (list && list.id) return true;
    return false;
  }

  toggleItem(list, product) {
    const $ctrl = this;
    const request = { listId: list.id, productId: product.id };
    let url = "CreateProductListItem.json";
    if ($ctrl.isInList(list)) {
      url = "DeleteProductListItem.json";
    } else {
      cache.record(list.id);
    }
    $ctrl.$cart.bus.send(url, request).then((res) => {
      $ctrl.productLists.load(true);
      $ctrl.$broadcast("refresh-product-lists", res);
    });
  }

  isInList(list, product) {
    const $ctrl = this;
    if (list && list.id && list.items && list.items.indexOf(product.id) >= 0)
      return true;
    return false;
  }

  addToNewList(product) {
    const $ctrl = this;
    const retailerId = $ctrl.$cart.retailerId || $session.retailerId;
    ProductListPrompt({
      request: {
        retailerAuthorization: retailerId ? { [retailerId]: true } : {},
      },
    }).then((list) => $ctrl.toggleItem(list, product));
  }

  quickView(product) {
    const $ctrl = this;
    return $ctrl.$cart.quickView(
      product.getCartItem(),
      $ctrl.query.results.map((p) => p.id),
      {
        placement: "right",
        backdrop: false,
      }
    ).finally(() => $ctrl.$broadcast("quickViewClosed", product));
  }

  jumpToTag(tagKind, tagLabel) {
    const $ctrl = this;
    const params = { [tagKind]: encodeURIComponent(tagLabel) };
    $ctrl.$state.go(
      $ctrl.baseRoute + ".multi-view",
      Object.assign({ tagCriteria: JSON.stringify(params) }, params)
    );
  }

  // openMessages(entityType, entityId) {
  //   const $ctrl = this;
  //   return EntityMessageList.open({entityType: entityType, entityId: entityId});
  // }
  likeProduct(product) {
    let $ctrl = this;
    if ($ctrl.$session.isAuthenticated) {
      var request = {
        Id: product.id,
      };
      $ctrl.$cart.bus
        .send("LikeProduct.json", request)
        .then(function (response) {
          if (response.status == "200") {
            product.hasLiked = true;
            product.likes = response.data.likes;
          }
        });
    }
  }
}
